export default "__VITE_ASSET__3f4917bf__"